import { render } from "./ParametersList.vue?vue&type=template&id=0422eb77&scoped=true"
import script from "./ParametersList.vue?vue&type=script&lang=js"
export * from "./ParametersList.vue?vue&type=script&lang=js"

import "./ParametersList.vue?vue&type=style&index=0&id=0422eb77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0422eb77"]])

export default __exports__